import React, { PureComponent, Fragment } from "react";
import TreeDataTable from "cp-react-tree-table";
import { connect } from "react-redux";
import Percentage from "../Common/Percentage/Percentage";
import { EntityIcon } from "../Common/Icons";
import styles from "./PeriodFinancialSheet.local.scss";
import { Pagination, Tooltip } from "antd";
import _ from "i18n";
import NumberFormat from "react-number-format";
import { getTimeByDurationFormat } from "Utils";
import StickyTableHeader from "../Common/StickyTableHeader/StickyTableHeader";
import { renderRatingStars } from "Utils";
import { setFinancialSheetStartPaginationState } from "../../actions/actions/financial-sheet";

class TreeTable extends PureComponent {
  treeTableRef = React.createRef();

  constructor(props) {
    super(props);
    this.treeTableRef = React.createRef();
  }

  render() {
    const header = {
      label: "",
      type: "header"
    };
    this.props.columns.forEach(c => {
      header[c] = {
        value: c,
        isHeader: true
      };
    });

    const data = [{ data: header }, ...this.props.dataSource];
    const { expandAll, parameterSettings } = this.props;
    let columns = [
      {
        name: _("name"),
        basis: "170px",
        grow:
          data &&
          data.length > 1 &&
          !data[1].data.profit.budgetaryBenchmarkRatio
            ? "2"
            : "1"
      },
      ...this.props.columns
    ].map(
      (col, index) =>
        index !== 0
          ? {
              name: _(col),
              basis: index < 1 ? "170px" : index < 3 ? "150px" : "100px",
              grow: "1"
            }
          : col
    );
    return (
      <div style={{ overflow: "scroll", position: "relative" }}>
        <StickyTableHeader
          columns={columns}
          benchmark={parameterSettings.benchmarkValue}
        />
        <TreeDataTable
          ref={elem => {
            if (elem) {
              this.treeTableRef = elem;
            }
            if (expandAll) {
              this.treeTableRef.expandAll(3);
            }
          }}
          height="auto"
          headerHeight="0"
          //   rowHeight="75"
          onChange={this.handleOnChange}
          data={data}
        >
          <TreeDataTable.Column
            key={"index"}
            renderCell={this.renderIndexCell}
            renderHeaderCell={this.renderHeaderCell("Name")}
            basis="170px"
            grow={
              data[1] && !data[1].data.profit.budgetaryBenchmarkRatio
                ? "2"
                : "1"
            }
          />

          {this.props.columns
            .slice(0, 2)
            .map(column => (
              <TreeDataTable.Column
                key={column}
                renderCell={this.renderCell(column)}
                renderHeaderCell={this.renderHeaderCell(column)}
                basis="150px"
                grow="1"
              />
            ))}
          {this.props.columns
            .slice(2, 5)
            .map(column => (
              <TreeDataTable.Column
                key={column}
                renderCell={this.renderCell(column)}
                renderHeaderCell={this.renderHeaderCell(column)}
                basis="100px"
                grow="1"
              />
            ))}
        </TreeDataTable>

        <Pagination
          pageSize={this.props.filters.limit}
          current={
            (this.props.filters.start + this.props.filters.limit) /
            this.props.filters.limit
          }
          hideOnSinglePage={true}
          total={this.props.totalData}
          onChange={this.handlePageChange}
          style={{ display: "flex", justifyContent: "center" }}
        />
      </div>
    );
  }

  handleOnChange = newValue => {
    this.setState({ treeValue: newValue });
  };

  handlePageChange = (page, pageSize) => {
    const { dispatch } = this.props;

    dispatch(setFinancialSheetStartPaginationState(page, pageSize));
    this.props.onPaginationChange(page, pageSize);
  };

  renderHeaderCell = c => {
    return () => {
      return (
        <div>
          <span>{c}</span>
        </div>
      );
    };
  };

  renderIndexCell = (row, metadata, toggleChildren) => {
    const { erpData } = this.props;
    let erpCollaborators = erpData && erpData.items.clients;
    const dataErp = erpCollaborators ? erpCollaborators : [];
    return (
      <Fragment>
        <div
          style={{
            paddingLeft: metadata.depth * 15 + "px",
            backgroundColor: row.label === "TOTAL" ? "#c8cdd2" : ""
          }}
          className={`cell ${row.type === "CLIENT" ? "level-2" : row.level} ${
            row.type === "CLIENT" && row.level !== "level-0" ? "white" : ""
          } ${metadata.hasChildren ? "with-children" : "without-children"}`}
        >
          {metadata.hasChildren ? (
            <span
              className={`toggle-button ${
                metadata.hasVisibleChildren ? "collapsed" : "expanded"
              }`}
              onClick={toggleChildren}
            />
          ) : (
            <span className={`toggle-button`} />
          )}
          <span
            className={
              (row.label &&
                parseInt(row.year, 10) > 2020 &&
                row.label.length >= 29) ||
              (row.label &&
                parseInt(row.year, 10) <= 2020 &&
                row.label.length >= 40)
                ? "label-wrap"
                : ""
            }
          >
            {row.label}
          </span>
        </div>
        {row.type !== "header" &&
          row.type === "CLIENT" && (
            <span
              className={styles.div_info}
              style={{
                backgroundColor:
                  row.level === "level-0" ? "#f1f2f4" : "#fffafa",
                border:
                  row.level === "level-0"
                    ? "1px solid #f1f2f4"
                    : "1px solid #fffafa",
                // marginRight: row.level === "level-0" ? "40px" : "0px",
                // width: parseInt(row.year, 10) <= 2020 ? "40px" : "99px"
                width: "64px"
              }}
            >
              <span
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                {row.attachedClients && row.attachedClients.length ? (
                  <Tooltip
                    placement="right"
                    title={
                      <div
                        style={{
                          textAlign: "left"
                        }}
                      >
                        <p>
                          {" "}
                          {_("attachedClients")}
                          {" : "}
                        </p>
                        {row.attachedClients.map(item => (
                          <p>{"- " + item.clientName}</p>
                        ))}
                      </div>
                    }
                  >
                    <div style={{ height: "18px" }}>
                      <EntityIcon
                        className={styles.info_icon}
                        color={"#6d7f92"}
                      />
                    </div>
                  </Tooltip>
                ) : (
                  ""
                )}
                {dataErp.map(erp => {
                  return erp[row.id] && erp[row.id].erpId ? (
                    <Tooltip
                      placement="right"
                      title={
                        <div>
                          <p>
                            {_("importedFrom")} : {erp[row.id].erpLabel}
                          </p>
                          <p>
                            {_("identifier")} : {erp[row.id].erpId}
                          </p>
                        </div>
                      }
                    >
                      <img
                        src="/img/icons/info.svg"
                        alt="text"
                        className={styles.info_icon}
                      />
                    </Tooltip>
                  ) : (
                    ""
                  );
                })}

                {row.client_recovr_external_id && (
                  <a href={row.client_recovr_external_id} target="_blank">
                    <Tooltip
                      placement="right"
                      title={
                        <div
                          style={{
                            textAlign: "left"
                          }}
                        >
                          Portail client
                        </div>
                      }
                    >
                      <img
                        src="/img/recovr-logo.png"
                        alt="recovr_logo"
                        width={12}
                      />
                    </Tooltip>
                  </a>
                )}
              </span>
            </span>
          )}
        {/* {row.type !== "header" &&
          row.type === "CLIENT" &&
          row.level === "level-0" && (
            <div>
              {parseInt(row.year, 10) > 2020 && (
                <span className={"action"} style={{ marginRight: "10%" }}>
                  <span
                    style={{
                      marginTop: "5px"
                    }}
                    onClick={() =>
                      this.props.handleConfigureQuickBudgetCurrentYear(
                        row.id,
                        row.year
                      )
                    }
                  >
                    <SettingIcon fill="#29394d" size="16" />
                  </span>
                  <span
                    style={{
                      fontSize: "10px",
                      color: "#06D9B1"
                    }}
                  >
                    {row.year}
                  </span>
                </span>
              )}

              <span className={"action"}>
                <span
                  style={{
                    marginTop: "5px"
                  }}
                  onClick={() =>
                    this.props.handleConfigureQuickBudget(row.id, row.year)
                  }
                >
                  <SettingIcon fill="#29394d" size="16" />
                </span>
                <span
                  style={{
                    fontSize: "10px",
                    color: `${row.nextYear.exist ? "#06D9B1" : "#FB235B"}`
                  }}
                >
                  {row.nextYear.value}
                </span>
              </span>
            </div>
          )} */}
      </Fragment>
    );
  };

  renderColumnCell = (row, field) => {
    switch (field) {
      case "PrestaTs":
      case "budgetH":
        return row[field] ? (
          <Fragment>
            <span>
              {`Total: `}
              {getTimeByDurationFormat(row[field].total)}

              <span
                className={row[field].diff != null ? "percentage" : ""}
                style={{ fontSize: "12px" }}
              >
                {row[field].diff != null ? (
                  <Percentage
                    percentage={row[field].diff}
                    comparison={per => per < 0}
                    hideIcon={true}
                    showSign={true}
                  />
                ) : (
                  ""
                )}
              </span>
              {/* {row.type == "CLIENT" &&
                row.level == "level-0" && (
                  <span
                    style={{
                      marginRight: "5px",
                      right: 0,
                      position: "absolute"
                    }}
                    onClick={() =>
                      this.props.handleConfigureQuickBudget(
                        row.id,
                        row.year,
                        field
                      )
                    }
                  >
                    <PelletGoIcon />
                  </span>
                )} */}
            </span>
            {row[field].subTotals && (
              <div className="sub">
                {row[field].subTotals.map(sub => (
                  <span key={sub.zone}>
                    {`${sub.zone}: `}
                    {getTimeByDurationFormat(sub.value)}
                  </span>
                ))}
              </div>
            )}
          </Fragment>
        ) : (
          ""
        );
      case "profit":
        return (
          <Fragment>
            <span>
              <NumberFormat
                value={row[field].revenue}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"€ "}
              />
            </span>
            <div className="sub">
              <span>
                {_("effectiveRate") + ": "}
                {row[field].ratio ? (
                  <NumberFormat
                    value={row[field].ratio}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    suffix={" €/heure "}
                  />
                ) : (
                  "0 €/heure "
                )}
              </span>
              {row[field].budgetaryBenchmarkRatio ||
              row[field].budgetaryBenchmarkRatio === 0 ? (
                <span>
                  {_("budgetaryRate") + ": "}
                  {row[field].ratio ? (
                    <NumberFormat
                      value={row[field].budgetaryBenchmarkRatio}
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      suffix={" €/heure "}
                    />
                  ) : (
                    "0 €/heure "
                  )}
                </span>
              ) : (
                ""
              )}
            </div>
          </Fragment>
        );
      case "benchmark":
        return (
          <Fragment>
            <span>
              <NumberFormat
                value={row[field].ratio}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
              />
            </span>
            <div className="sub">
              <span>{renderRatingStars(row.id, row[field])}</span>
            </div>
          </Fragment>
        );
      case "budgetaryBenchmark":
        return (
          <Fragment>
            <span>
              <NumberFormat
                value={row[field].ratio}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
              />
            </span>
            <div className="sub">
              <span>{renderRatingStars(row.id, row[field])}</span>
            </div>
          </Fragment>
        );
      case "budgetEco":
        return (
          <Fragment>
            <span>
              <NumberFormat
                value={row[field].total}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"€ "}
              />
            </span>
            <div className="sub">
              <span>
                {_("effectiveRate") + ": "}
                {row[field].ratio ? (
                  <NumberFormat
                    value={row[field].ratio}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    suffix={" €/heure "}
                  />
                ) : (
                  "0 €/heure "
                )}
              </span>
            </div>
          </Fragment>
        );
      case "Encours":
        return (
          <span>
            <NumberFormat
              value={row[field].amount}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
              prefix={"€ "}
            />
          </span>
        );
      default:
        return "";
    }
  };

  renderCell = field => {
    return row => {
      return (
        <div
          className={`cell ${row.type === "CLIENT" ? "level-2" : row.level} ${
            row.type === "CLIENT" && row.level !== "level-0" ? "white" : ""
          } ${"vertical"}`}
          style={{
            backgroundColor: row.label === "TOTAL" ? "#c8cdd2" : ""
          }}
        >
          {row[field].isHeader
            ? row[field].value
            : this.renderColumnCell(row, field)}
        </div>
      );
    };
  };
}

const mapStateToProps = state => ({
  filters: state.financialSheet.periodTree.filter
});

export default connect(mapStateToProps)(TreeTable);



// WEBPACK FOOTER //
// ./src/components/Financial/TreeTable.js